import React, { useContext } from "react";
import expandBtn from "../../assets/expand.svg";
import collapseBtn from "../../assets/collapse.svg";
import classes from "./Navbar.module.scss";
import { MenuContext } from "../../store/menu_context";
import useWindowSize from "../../hooks/useWindowSize";
import "./MobileMenu.scss";
import MobileMenuCont from "./MobileMenuCont";
import BlockedModal from "./BlockedModal";
import NavInfo from "./NavInfo";
import useSessionInfo from "../../hooks/useSessionInfo";
import useUserUIState from "../../hooks/useUserUIState";
import MobileMenu from "./MobileMenu";

const Navbar = ({ onSessionLoadedHandler, triggerRerender, hasSession,clientData, sessionData, blockedData, onCloseBlock }) => {
  const { isMenuCollapsed, changeMenuVisibility } = useContext(MenuContext);
  const { width } = useWindowSize();

  const onToggleMenuHandler = () => {
    if (width > 768) {
      changeMenuVisibility((prev) => !prev);
    }
  };

  /*const { hasSession, clientData, sessionData, blockedData } = useSessionInfo(
    onSessionLoadedHandler,
    triggerRerender
  );*/
  useUserUIState();

  return (
    <div className={`d-flex justify-content-between p-3 ${classes.container}`}>
      <button onClick={onToggleMenuHandler}>
        {width > 768 &&
          (isMenuCollapsed ? (
            <img src={expandBtn} alt="expand" />
          ) : (
            <img src={collapseBtn} alt="collapse" />
          ))}
        {/*width <= 768 && <MobileMenuCont />*/}
        {width <= 768 && <MobileMenu/>}
      </button>
      {hasSession && <NavInfo clientData={clientData} sessionData={sessionData} />}

      <BlockedModal blockedData={blockedData} onCloseBlock={onCloseBlock} />
    </div>
  );
};

export default Navbar;
